import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Form } from '@entrata/portals-common/lib/components/forms'
import ActionModal from './ActionModal'
import { ModalControl } from '@entrata/portals-common/lib/components'
import styled from '@emotion/styled'
import { SettingsListItem } from 'portal-modules/common/components/settings-list'
import ClassifiedSendMessageModal from './ClassifiedSendMessageModal'
import Button from 'portal-modules/common/components/Button'
import { connect } from 'react-redux'
import { updateUserSettings } from 'portal-modules/auth/redux/modules/userSettings'

const StyledButton = styled(Button)`
  margin-top: 32px;
  text-transform: uppercase;
`

const ClassifiedAdModal = props => {
  const handleSubmit = ({ values }) => {
    const favorites = values.favorite
      ? [...props.favorites, props.id]
      : props.favorites.filter(value => value !== props.id)

    props.onSubmit({ classifiedFavorites: favorites })
    props.onClose()
  }

  const initialFieldState = {
    favorite: {
      required: false,
      value: props.favorites.includes(props.id),
    },
  }

  return (
    <ActionModal {...props}>
      {() => (
        <Form onSubmit={handleSubmit} initialFieldState={initialFieldState}>
          <Form.Field name='favorite' id='favorite'>
            {fieldProps => (
              <SettingsListItem
                {...fieldProps}
                label={__('Add to my favorites')}
              />
            )}
          </Form.Field>
          <ModalControl>
            {({ onClick, onClose, ref, ...rest }) => (
              <Fragment>
                <StyledButton
                  title={__('Message the seller')}
                  appearance='secondary'
                  onClick={onClick}
                  ref={ref}
                  size='large'
                >
                  {__('message the seller')}
                </StyledButton>
                <ClassifiedSendMessageModal
                  {...props}
                  {...rest}
                  onClose={() => {
                    props.onClose()
                    onClose()
                  }}
                />
              </Fragment>
            )}
          </ModalControl>
          <Form.Actions
            render={({ hasErrors }) => (
              <ActionModal.Button
                title={__('SAVE')}
                disabled={hasErrors}
                type='submit'
              />
            )}
          />
        </Form>
      )}
    </ActionModal>
  )
}

ClassifiedAdModal.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number.isRequired,
    PropTypes.string.isRequired,
  ]),
  title: PropTypes.string,
  seller: PropTypes.string,
  amount: PropTypes.number,
  image: PropTypes.string,
  favorite: PropTypes.bool,
  details: PropTypes.object,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func.isRequired,
  favorites: PropTypes.arrayOf(PropTypes.string),
}

export default connect(
  ({ userSettings }) => ({ favorites: userSettings.classifiedFavorites || [] }),
  { onSubmit: updateUserSettings },
)(ClassifiedAdModal)
